export default "__VITE_ASSET__DSOJ_LdJ__"